import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Информатика. 7-9 классы",
        subject: "Алгоритмы и программирование в основной школе: углубленный уровень изучения",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Алгоритмы и программирование в основной школе: углубленный уровень изучения",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Босова Людмила Леонидовна",
                grade: "д.пед.н.",
                subGrade: "член-корреспондент РАО, профессор, заслуженный учитель РФ",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Линия «Алгоритмизация и программирование» – традиционная содержательная линия школьного курса информатики, освоение которой, по сути, способствует знакомству обучающихся с методологией решения широкого спектра жизненных задач и имеет в связи с этим ярко выраженный метапредметный характер. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Тематический раздел «Алгоритмы и программирование», входящий во все примерные рабочие программы по информатике для основной школы, непосредственно направлен на развитие алгоритмического мышления как необходимого условия профессиональной деятельности в современном информационном обществе, предполагающего способность обучающегося: </p>"
                        },
                        {
                            type: "block",
                            listLabel: "",
                            unorderedList: [
                                "разбивать сложные задачи на более простые подзадачи; ",
                                "сравнивать новые задачи с задачами, решёнными ранее; ",
                                "определять шаги для достижения результата;",
                                "осваивать базовые навыки программирования как важной составляющей цифровых навыков современного человека. "
                            ]
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Основные трудности, связанные с изучением алгоритмизации и программирования: позднее начало и небольшое время, отводимое на освоение соответствующего содержания; преобладание задач с математическим контекстом (проверка делимости одного целого числа на другое; решение квадратного уравнения, имеющего вещественные корни; нахождение наибольшего общего делителя двух натуральных чисел; разложение натурального числа на простые сомножители; разбиение записи натурального числа в позиционной системе с основанием, меньшим или равным 10, на отдельные цифры и другие). </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>При выборе для 7–9 классов углубленного уровня освоения информатики появляется возможность выделить на освоение алгоритмизации и программирования 86 часов учебного времени, начав этот процесс с 7 класса. Появляется возможность существенно расширить спектр решаемых задач за счёт тематики, связанной с компьютерной графикой, обработкой символьных данных, рассмотрением методов и алгоритмов обработки одномерных и двумерных массивов, знакомства с динамическим программированием и так далее. Обучающиеся получают реальную возможность уже к концу обучения на уровне основного общего образования получить базовые навыки программирования – важной составляющей цифровых навыков современного человека.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Изучение информатики в 7–9 классах на углубленном уровне – новая задача для учителя информатики. В видеоролике будет представлена одна из наиболее сложных для восприятия учениками тем линии «Алгоритмизация и программирование», а именно – работа с одномерными целочисленными массивами, включая их сортировку и двоичный поиск в упорядоченном массиве. </p>"
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">В практической̆ деятельности человек часто использует всевозможные таблицы. Это, например, список учеников в классном журнале, табель успеваемости, таблица результатов спортивных соревнований и многое другое. Чаще всего встречаются линейные и прямоугольные таблицы. </p>
                    <p style="text-indent: 2vw;">Линейная таблица или одномерный массив представляет собой набор однотипных данных, записанных в одну строку или один столбец. </p>
                    <p style="text-indent: 2vw;">Прямоугольная таблица или двумерный массив — это упорядоченный некоторым образом набор строк, содержащих одинаковое количество элементов.</p>
                    <p style="text-indent: 2vw;">Линейные и прямоугольные таблицы наглядно можно представить как аналоги привычных нам объектов — рядов шкафчиков в раздевалках, почтовых ящиков, ячеек для хранения сумок в супермаркетах.</p>
                    <p style="text-indent: 2vw;">При изучении информатики в основной школе на углублённом уровне ученикам предстоит освоить алгоритмы обработки  больших объёмов однотипных данных, организованных в массивы. Массив — это набор элементов одного типа, которым присвоено общее имя. Каждый элемент массива имеет свой номер (индекс).</p>
                    <p style="text-indent: 2vw;">Типовые алгоритмы обработки одномерных массивов ученики осваивают в 8 классе – согласно примерной рабочей программе по информатике базового уровня. К таким алгоритмам относятся:</p>
                    <p style="text-indent: 2vw;">
                    <ul>
                    <li>заполнение числового массива случайными числами, в соответствии с формулой или путём ввода чисел;</li>
                    <li>нахождение суммы элементов массива;</li>
                    <li>линейный поиск заданного значения в массиве;</li>
                    <li>подсчёт элементов массива, удовлетворяющих заданному условию;</li>
                    <li>нахождение минимального (максимального) элемента массива.</li>
                    </ul>
                    </p>
                    <p style="text-indent: 2vw;"></p>
                
                
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Следующий этап – рассмотрение нового материала, а именно – вопросов, связанных с сортировкой массива. Под сортировкой (упорядочением) массива понимают перераспределение его элементов в некотором определённом порядке.</p>
                    <p style="text-indent: 2vw;">Порядок, при котором в массиве первый элемент имеет самое маленькое значение, а значение каждого следующего элемента не меньше значения предыдущего элемента, называют неубывающим.</p>
                    <p style="text-indent: 2vw;">Порядок, при котором в массиве первый элемент имеет самое большое значение, а значение каждого следующего элемента не больше значения предыдущего элемента, называют невозрастающим.</p>
                    <p style="text-indent: 2vw;">Цель сортировки — облегчить последующий поиск элементов: искать нужный элемент в упорядоченном массиве легче. </p>
                    <p style="text-indent: 2vw;">Разработано множество методов сортировки массивов. С учениками желательно рассмотреть хотя бы некоторые из них.</p>
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Бешенков, С. А. Организация занятий по обучению программированию в курсе информатики и во внеурочной деятельности с использованием среды программирования и моделирования TRIK Studio / С. А. Бешенков, М. И. Шутикова, В. И. Филиппов // Информатика в школе. – 2021. – № 8(171). – С. 5-11. – DOI 10.32517/2221-1993-2021-20-8-5-11. – EDN LFFKKB.",
                "Босова, Л. Л. Обработка символьных данных: от простого к сложному / Л. Л. Босова, Н. А. Аквилянов // Информатика в школе. – 2022. – № 6(179). – С. 5-11. – DOI 10.32517/2221-1993-2022-21-6-5-11. – EDN DVGZGT.",
                "Босова, Л. Л. Программирование как инструмент формирования вычислительного мышления обучающихся / Л. Л. Босова // Информатика в школе. – 2020. – № 10(163). – С. 4-10. – DOI 10.32517/2221-1993-2020-19-10-4-10. – EDN GURIPH.",
                "Долинский, М. С. Решение игровых задач с помощью рекурсии / М. С. Долинский // Информатика в школе. – 2021. – № 9(172). – С. 45-52. – DOI 10.32517/2221-1993-2021-20-9-43-50. – EDN XQIAMP.",
                "Долинский, М. С. Решение рекурсивных задач по определению / М. С. Долинский // Информатика в школе. – 2020. – № 2(155). – С. 60-66. – DOI 10.32517/2221-1993-2020-19-2-60-66. – EDN EAYQZS.",
                "Завьялова, О. А. Возможности онлайн-сред программирования при обучении языку Python в школе / О. А. Завьялова, В. К. Маркелов // Информатика в школе. – 2022. – № 3(176). – С. 75-82. – DOI 10.32517/2221-1993-2022-21-3-75-82. – EDN WMAWRT.",
                "Заславская, О. Ю. Особенности методики преподавания цикла For в языке Python в средней школе / О. Ю. Заславская, О. Д. Любутов // Информатика в школе. – 2022. – № 4(177). – С. 70-73. – DOI 10.32517/2221-1993-2022-21-4-70-73. – EDN KGUBSE.",
                "Костицин, К. Н. О подходах к обучению программированию в России и за рубежом / К. Н. Костицин, П. К. Чернова // Информатика в школе. – 2021. – № 7(170). – С. 20-26. – DOI 10.32517/2221-1993-2021-20-7-20-26. – EDN IXIEVD.",
                "Кривоплясова, Е. В. Методика обучения основам программирования на языке Python / Е. В. Кривоплясова, В. Ю. Нефедова, А. В. Прилепина // Информатика в школе. – 2020. – № 3(156). – С. 24-30. – DOI 10.32517/2221-1993-2020-19-3-24-30. – EDN NCKNDR.",
                "Поляков, К. Ю. Динамическое программирование в задачах обработки последовательностей ЕГЭ по информатике / К. Ю. Поляков // Информатика в школе. – 2020. – № 5(158). – С. 55-63. – DOI 10.32517/2221-1993-2020-19-5-55-63. – EDN SXZKLG.",
            ],
            posob: [
                "Босова Л.Л., Босова А.Ю., Аквилянов Н.А. Информатика. 7–9 классы. Компьютерный практикум. – \tМосква: БИНОМ. Лаборатория знаний, 2021",
                "Поляков К.Ю. Программирование. Python. С++. Часть 1: учебное пособие ",
                "Поляков К.Ю. Программирование. Python. С++. Часть 2: учебное пособие ",
                "Поляков К.Ю. Программирование. Python. С++. Часть 3: учебное пособие ",
                "Поляков К.Ю. Программирование. Python. С++. Часть 4: учебное пособие ",
            ],
            sites: [
                "Фоксфорд: учебник URL: https://foxford.ru/wiki/informatika (дата обращения: 25.04.2023)",
                "Библиотека МЭШ [Электронный ресурс] URL:: https://uchebnik.mos.ru/catalogue (дата обращения: 25.04.2022) ",
                "Российская электронная школа URL:: https://resh.edu.ru/  (дата обращения: 25.04.2023) ",
            ],
            filesToDownload: [
                {
                    link: "./files/work.pdf",
                    fileName: "Пример самостоятельной работы по теме «Подсчет количества путей в графе»"
                },
                {
                    link: "./files/examples.pdf",
                    fileName: "Примеры заданий по информатике"
                }
            ]
        }
    ],
};
